import { render } from "./TrainingChartsPage.vue?vue&type=template&id=3802c190&scoped=true"
import script from "./TrainingChartsPage.vue?vue&type=script&lang=js"
export * from "./TrainingChartsPage.vue?vue&type=script&lang=js"

import "./TrainingChartsPage.vue?vue&type=style&index=0&id=3802c190&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3802c190"]])

export default __exports__